module.exports = __webpack_public_path__ + "media/newstyle/images/logo-clube-de-autores-54e294ced590406b2bd7b7be75109303.svg";